import { CoreProviders as e } from "./CoreProviders.mjs";
import { ScrollToTop as t } from "./ScrollToTop.mjs";
import "react";
import { RootProvider as n } from "@maat/ds-core";
import { BrowserRouter as r } from "react-router-dom";
import { DocumentHead as i } from "@maat/router";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/AppProviders.tsx
var s = ({ children: s, oauth: c, i18n: l }) => /* @__PURE__ */ a(e, {
	oauth: c,
	i18n: l,
	children: /* @__PURE__ */ a(n, {
		defaultMode: "light",
		children: /* @__PURE__ */ o(r, { children: [
			/* @__PURE__ */ a(t, {}),
			/* @__PURE__ */ a(i, {}),
			s
		] })
	})
});
//#endregion
export { s as AppProviders };
